import log from "src/helpers/log";

const parseInlineLinkText = (text: string) => {
	try {
		const blurbParts: (
			| {
					type: "text";
					text: string;
			  }
			| {
					type: "link";
					text: string;
					url: string;
			  }
		)[] = [];
		for (const part of text.split(/(\[.*?\]\(.*?\))/)) {
			if (part.startsWith("[") && part.endsWith(")")) {
				const linkParts = part.match(/\[(.*?)\]\((.*?)\)/);
				const text = linkParts?.[1];
				const url = linkParts?.[2];
				if (text && url) {
					blurbParts.push({
						type: "link",
						text,
						url,
					});
				}
			} else {
				const text = part.trimEnd();
				if (text) {
					blurbParts.push({
						type: "text",
						text,
					});
				}
			}
		}

		// Need to add a text in between two adjacent links
		for (let i = 0; i < blurbParts.length - 1; i++) {
			const curPart = blurbParts[i];
			const nextPart = blurbParts[i + 1];
			if (
				curPart?.type === "link" &&
				nextPart?.type === "link" &&
				// Some links are intentionally split for multi-line display
				curPart.url !== nextPart.url
			) {
				// If two links are adjacent, insert a space text part between them
				blurbParts.splice(i + 1, 0, {
					type: "text",
					text: " ",
				});
				i++; // Skip the newly inserted text part
			}
		}

		return blurbParts;
	} catch (err) {
		log.error({ err }, "Error parsing inline link text");
		return [{ type: "text" as const, text: text }];
	}
};
export default parseInlineLinkText;
